import {
  StackLayout,
  HeadingText,
  ParagraphText,
  useMediaQuery,
  queryHelpers,
  ImageMessage,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { BaseModalContainer } from 'components/modals/common/base-modal.component';
import exitWarning from 'assets/exit-warning.png';
import { ModalActionButton } from './common/modal-action-button.component';

export interface Props {
  onSubmit: () => void;
}
export const DeleteAccountModal = ({ onSubmit }: Props) => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.only('mobile'));

  return (
    <BaseModalContainer
      title={formatMessage({ id: 'DELETE_YOUR_ACCOUNT' })}
      footer={
        <StackLayout
          horizontalAlignment="end"
          orientation={{
            '@initial': 'horizontal',
            '@mobile': 'vertical',
          }}
          spacing="$one"
          css={{ flexGrow: 0 }}
        >
          <ModalActionButton
            actionType="cancel"
            labelId="NEVER_MIND"
            isMobile={isMobile}
            cssStyle={{ color: '$secondaryTextDefault' }}
          />
          <ModalActionButton
            actionType="submit"
            onClick={onSubmit}
            labelId="YES_DELETE_ACCOUNT"
            isMobile={isMobile}
            isDestructive
          />
        </StackLayout>
      }
    >
      <ImageMessage
        image={exitWarning}
        imageWidth={146}
        css={{
          flexGrow: 1,
          padding: '$two $half $five $half',
          textAlign: 'left',
          '@mobile': { textAlign: 'center' },
        }}
      >
        <HeadingText
          level="2"
          size={{
            '@initial': 'lg',
            '@mobile': 'xl',
          }}
          css={{ paddingBlock: '$one', fontWeight: 'bold' }}
        >
          {formatMessage({ id: 'ARE_YOU_SURE' })}
        </HeadingText>
        <ParagraphText>
          {formatMessage({ id: 'DELETE_ACCOUNT_BODY_1' })}
        </ParagraphText>
        <ParagraphText css={{ marginBlock: '$one' }}>
          {formatMessage({ id: 'DELETE_ACCOUNT_BODY_2' })}
        </ParagraphText>
      </ImageMessage>
    </BaseModalContainer>
  );
};
